import src from "IMAGE";
export default { src, width: 512, height: 512, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAR0lEQVR42nWPSQ4AIAgD+yJN+f/Fl7km0jR6aAgwZUHU1pe4VE68tZmDNYsv6AIUIMQEmtMFd+mKDfyOpAI63g3YzZKNsDcHykiICibiBcYAAAAASUVORK5CYII="};
